export const ru = {
    fatalError: 'Во время копирования произошла ошибка. Попробуйте позже'
};
